// PressMediaPage.js
import React from 'react';
import { Box, Typography, Container, Breadcrumbs, Link as MuiLink, Grid, Card, CardContent, CardActions, } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const PressMediaPage = () => {
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Legal & Company', path: '/company' },
    { name: 'Press & Media', path: '/company/press' },
  ];

  const pressReleases = [
    {
      id: 1,
      title: 'Our Platform Announces Record Growth in Q2 2024',
      date: 'July 1, 2024',
      source: 'Industry News Daily',
      excerpt: 'Our innovative scrap trading platform reports significant user growth and transaction volume in the second quarter of 2024, highlighting increasing demand for efficient recycling solutions...',
      link: '#press-release-1', // Placeholder link
    },
    {
      id: 2,
      title: 'New Partnership to Enhance Global Logistics for Scrap Materials',
      date: 'June 15, 2024',
      source: 'Recycling Today',
      excerpt: 'A strategic collaboration aims to streamline cross-border logistics for various scrap materials, reducing costs and environmental impact...',
      link: '#press-release-2', // Placeholder link
    },
    {
      id: 3,
      title: 'CEO Discusses Circular Economy Vision at Global Summit',
      date: 'May 28, 2024',
      source: 'Environmental Times',
      excerpt: 'Our CEO delivered a keynote address on the importance of circular economy principles in the materials industry, emphasizing technology\'s role...',
      link: '#press-release-3', // Placeholder link
    },
    {
      id: 4,
      title: 'Innovation in E-Waste Recycling: A Case Study',
      date: 'April 10, 2024',
      source: 'Tech & Green Magazine',
      excerpt: 'A deep dive into our recent project demonstrating advanced techniques for recovering valuable materials from electronic waste...',
      link: '#press-release-4', // Placeholder link
    },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: 2 }}>
      <Container sx={{ py: { xs: 4, md: 6 }, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
        {/* Breadcrumbs */}
        <Box sx={{ mb: { xs: 2, md: 4 }, px: { xs: 2, md: 0 } }}>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs.map((crumb, index) => (
              crumb.path ? (
                <MuiLink component={RouterLink} to={crumb.path} key={index} underline="hover" color="text.secondary" variant="body2">
                  {crumb.name}
                </MuiLink>
              ) : (
                <Typography key={index} color="text.primary" variant="body2">{crumb.name}</Typography>
              )
            ))}
          </Breadcrumbs>
        </Box>

        <Typography variant="h3" align="center" fontWeight={700} sx={{ mb: { xs: 4, md: 6 }, color: 'text.primary' }}>
          Press & Media
        </Typography>

        <Typography variant="body1" align="center" sx={{ mb: { xs: 4, md: 6 }, maxWidth: '800px', mx: 'auto', color: 'text.secondary' }}>
          Stay informed about our latest news, announcements, and media coverage. This section provides access to our official press releases and mentions in leading publications.
        </Typography>

        <Box sx={{ mt: 6 }}>
          <Typography variant="h4" fontWeight={700} sx={{ mb: 4, color: 'primary.dark', textAlign: 'center' }}>
            Latest Press Releases
          </Typography>
          <Grid container spacing={4}>
            {pressReleases.map((release) => (
              <Grid item xs={12} sm={6} md={4} key={release.id}>
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 2,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                    },
                  }}
                >
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" component="div" fontWeight={600} sx={{ color: 'primary.dark', mb: 1 }}>
                      {release.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      {release.source} | {release.date}
                    </Typography>
                    <Typography variant="body1" color="text.primary">
                      {release.excerpt}
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
                    <MuiLink component={RouterLink} to={release.link} size="small" sx={{ fontWeight: 500, color: 'primary.main' }}>
                      Read Full Release &rarr;
                    </MuiLink>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
          <Box sx={{ mt: 6, textAlign: 'center' }}>
            <Typography variant="h5" fontWeight={600} sx={{ mb: 2, color: 'text.primary' }}>
              Media Inquiries
            </Typography>
            <Typography variant="body1" color="text.secondary">
              For all media-related inquiries, please contact our press team at:{' '}
              <MuiLink href="mailto:media@example.com" color="primary.main" underline="hover">media@example.com</MuiLink>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PressMediaPage;
